module.exports = __webpack_public_path__ + "img/index1.3b6365fc.jpg";